import {
  Box,
  Container,
  Typography,
  ThemeProvider,
  createTheme,
  Paper,
} from "@mui/material";
import ToolImg from "../../assets/Tools1.png";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1a237e",
    },
    secondary: {
      main: "#ff9800",
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#4a4a4a",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h3: {
      fontWeight: 800,
      fontSize: "2.5rem",
      lineHeight: 1.2,
      "@media (max-width:900px)": {
        fontSize: "2rem",
      },
      "@media (max-width:600px)": {
        fontSize: "1.75rem",
      },
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.4,
      "@media (max-width:900px)": {
        fontSize: "1.25rem",
      },
      "@media (max-width:600px)": {
        fontSize: "1.1rem",
      },
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 500,
    },
  },
});

const ToolsFeatureSection = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          bgcolor: "#ffffff",
          py: { xs: 6, md: 10 },
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Container maxWidth="xl">
          {/* Header Section */}
          <Box sx={{ textAlign: "center", mb: { xs: 6, md: 10 } }}>
            <Typography
              variant="h3"
              component="h2"
              sx={{
                mb: 2,
                px: 2,
              }}
            >
              Tools You Spend Thousands For <br />
              <Box
                component="span"
                sx={{
                  color: "secondary.main",
                  display: "inline",
                }}
              >
                Free with Justtawk
              </Box>
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: "text.primary",
                fontWeight: 600,
                px: 2,
              }}
            >
              Set Up in 5 Minutes — Start Connecting Instantly.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: { xs: 2, md: 10 },
            }}
          >
            <img
              src={ToolImg}
              alt="Tool"
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default ToolsFeatureSection;
